var _classCallCheck = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Projects\\SoLiDRDP\\solid-rdm\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

/**
 * Local dependencies
 */
var Algorithm = require('../dictionaries/Algorithm');

var KeyAlgorithm = require('../dictionaries/KeyAlgorithm');

var RegisteredAlgorithms = require('./RegisteredAlgorithms');

var _require = require('../errors'),
    NotSupportedError = _require.NotSupportedError;
/**
 * Supported Operations
 */


var operations = ['encrypt', 'decrypt', 'sign', 'verify', 'deriveBits', 'digest', // THIS WASN'T IN THE LIST. PROBABLY GETTING SOMETHING WRONG HERE
'wrapKey', 'unwrapKey', 'generateKey', 'importKey', 'exportKey', 'getLength'];
/**
 * SupportedAlgorithms
 */

var SupportedAlgorithms =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Constructor
   */
  function SupportedAlgorithms() {
    var _this = this;

    _classCallCheck(this, SupportedAlgorithms);

    operations.forEach(function (op) {
      _this[op] = new RegisteredAlgorithms();
    });
  }
  /**
   * Supported Operations
   */


  _createClass(SupportedAlgorithms, [{
    key: "define",

    /**
     * Define Algorithm
     */
    value: function define(alg, op, type) {
      var registeredAlgorithms = this[op];
      registeredAlgorithms[alg] = type;
    }
    /**
     * Normalize
     */

  }, {
    key: "normalize",
    value: function normalize(op, alg) {
      if (typeof alg === 'string') {
        return this.normalize(op, new KeyAlgorithm({
          name: alg
        }));
      }

      if (typeof alg === 'object') {
        var registeredAlgorithms = this[op];
        var initialAlg;

        try {
          initialAlg = new Algorithm(alg);
        } catch (error) {
          return error;
        }

        var algName = initialAlg.name;
        algName = registeredAlgorithms.getCaseInsensitive(algName);

        if (algName === undefined) {
          return new NotSupportedError(alg.name);
        }

        var desiredType, normalizedAlgorithm;

        try {
          desiredType = require(registeredAlgorithms[algName]);
          normalizedAlgorithm = new desiredType(alg);
          normalizedAlgorithm.name = algName;
        } catch (error) {
          return error;
        }

        var dictionaries = desiredType.dictionaries;

        for (var i = 0; i < dictionaries.length; i++) {
          var dictionary = dictionaries[i];
          var members = dictionary.members;

          for (var key in members) {
            var member = members[key];
            var idlValue = normalizedAlgorithm[key];

            try {
              if (member === 'BufferSource' && idlValue !== undefined) {
                normalizedAlgorithm[key] = idlValue.slice();
              }

              if (member === 'HashAlgorithmIdentifier') {
                var hashAlgorithm = this.normalize('digest', idlValue);

                if (hashAlgorithm instanceof Error) {
                  return hashAlgorithm;
                }

                normalizedAlgorithm[key] = hashAlgorithm;
              }

              if (member === 'AlgorithmIdentifier') {
                normalizedAlgorithm[key] = this.normalize(WTF, idlValue);
              }
            } catch (error) {
              return error;
            }
          }
        }

        return normalizedAlgorithm;
      }
    }
  }], [{
    key: "operations",
    get: function get() {
      return operations;
    }
  }]);

  return SupportedAlgorithms;
}();
/**
 * Export
 */


module.exports = SupportedAlgorithms;